import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
export class VehicleWithNumberOnlyDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.vehicleNumber = initializer.vehicleNumber;
    }
}
